import { FC } from "react";

type Props = {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
};

const Instagram: FC<Props> = ({
  width = 24,
  height = 24,
  className,
  color = "white",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9471 8.30545C20.9376 7.54801 20.7958 6.79805 20.5281 6.08945C20.297 5.49128 19.9433 4.94805 19.4899 4.49462C19.0365 4.04118 18.4932 3.68756 17.8951 3.45645C17.1954 3.19369 16.4563 3.05167 15.7091 3.03645C14.7471 2.99345 14.4421 2.98145 12.0001 2.98145C9.55807 2.98145 9.24507 2.98145 8.29007 3.03645C7.54322 3.05178 6.80439 3.1938 6.10507 3.45645C5.50691 3.68756 4.96368 4.04118 4.51024 4.49462C4.0568 4.94805 3.70318 5.49128 3.47207 6.08945C3.20977 6.78882 3.06809 7.52765 3.05307 8.27445C3.01007 9.23745 2.99707 9.54245 2.99707 11.9844C2.99707 14.4264 2.99707 14.7384 3.05307 15.6944C3.06807 16.4424 3.20907 17.1804 3.47207 17.8814C3.70341 18.4795 4.05724 19.0226 4.51085 19.4759C4.96446 19.9291 5.50782 20.2826 6.10607 20.5134C6.80359 20.7863 7.54248 20.9385 8.29107 20.9634C9.25407 21.0064 9.55907 21.0194 12.0011 21.0194C14.4431 21.0194 14.7561 21.0194 15.7111 20.9634C16.4582 20.9485 17.1974 20.8069 17.8971 20.5444C18.4946 20.3123 19.0373 19.9583 19.4906 19.505C19.9439 19.0517 20.2979 18.509 20.5301 17.9114C20.7931 17.2114 20.9341 16.4734 20.9491 15.7244C20.9921 14.7624 21.0051 14.4574 21.0051 12.0144C21.0031 9.57245 21.0031 9.26245 20.9471 8.30545ZM11.9941 16.6024C9.44007 16.6024 7.37107 14.5334 7.37107 11.9794C7.37107 9.42545 9.44007 7.35645 11.9941 7.35645C13.2202 7.35645 14.396 7.84351 15.263 8.71049C16.13 9.57747 16.6171 10.7533 16.6171 11.9794C16.6171 13.2055 16.13 14.3814 15.263 15.2484C14.396 16.1154 13.2202 16.6024 11.9941 16.6024ZM16.8011 8.26344C16.6595 8.26358 16.5192 8.23578 16.3884 8.18166C16.2575 8.12753 16.1386 8.04813 16.0385 7.948C15.9384 7.84787 15.859 7.72898 15.8049 7.59813C15.7507 7.46729 15.7229 7.32705 15.7231 7.18545C15.7231 7.04395 15.7509 6.90383 15.8051 6.7731C15.8592 6.64238 15.9386 6.52359 16.0387 6.42354C16.1387 6.32348 16.2575 6.24411 16.3882 6.18997C16.519 6.13582 16.6591 6.10795 16.8006 6.10795C16.9421 6.10795 17.0822 6.13582 17.2129 6.18997C17.3436 6.24411 17.4624 6.32348 17.5625 6.42354C17.6625 6.52359 17.7419 6.64238 17.7961 6.7731C17.8502 6.90383 17.8781 7.04395 17.8781 7.18545C17.8781 7.78145 17.3961 8.26344 16.8011 8.26344Z"
        fill={color}
      />
      <path
        d="M11.9942 14.9816C13.6527 14.9816 14.9972 13.6371 14.9972 11.9786C14.9972 10.3201 13.6527 8.97559 11.9942 8.97559C10.3357 8.97559 8.99121 10.3201 8.99121 11.9786C8.99121 13.6371 10.3357 14.9816 11.9942 14.9816Z"
        fill={color}
      />
    </svg>
  );
};

export default Instagram;
